import { render, staticRenderFns } from "./pushConfig.vue?vue&type=template&id=79ddb58c&scoped=true"
import script from "./pushConfig.vue?vue&type=script&lang=js"
export * from "./pushConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddb58c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ddb58c')) {
      api.createRecord('79ddb58c', component.options)
    } else {
      api.reload('79ddb58c', component.options)
    }
    module.hot.accept("./pushConfig.vue?vue&type=template&id=79ddb58c&scoped=true", function () {
      api.rerender('79ddb58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushConfig.vue"
export default component.exports